import { graphql } from '~publish/graphql'

import { PostUnreadMentionCount } from './fragments/PostUnreadMentionCount'
import { PostUnreadNoteCount } from './fragments/PostUnreadNoteCount'

/**
 * The composer holds the Post as legacy RPC data, which carries no allowed
 * actions. Both the header and panel read the normalized Post here; the
 * header keeps its summary loaded even while the panel is closed.
 */
export const GetPostForComposerNotes = graphql(
  `
    query GetPostForComposerNotes(
      $id: PostId!
      $includeNotesSummary: Boolean! = false
    ) {
      post(input: { id: $id }) {
        id
        allowedActions
        channel {
          id
        }
        ...PostUnreadNoteCount @include(if: $includeNotesSummary)
        ...PostUnreadMentionCount @include(if: $includeNotesSummary)
      }
    }
  `,
  [PostUnreadNoteCount, PostUnreadMentionCount],
)
